import React, { useEffect } from 'react';

export function useMount(callback: React.EffectCallback): void {
  // Only run callback once on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}
